import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import LandingPage from './pages/LandingPage';
import ShopAdminPage from './pages/ShopAdminPage';
import ShopDashboardPage from './pages/ShopDashboardPage';
import KioskLivePage from './pages/KioskLivePage';
import InstanceAdminPage from './pages/InstanceAdminPage';
import ApproveOrderPage from './pages/ApproveOrderPage';
import PhotowallPage from './pages/PhotowallPage';
import MBTIPlaygroundPage from './pages/MBTIPlaygroundPage';
import { AuthProvider } from './contexts/AuthContext';
import { RequireRole, RequireShopOwner } from './contexts/RouteGuards';
import './App.css';

const ShopMasterPage = React.lazy(() => import('./pages/ShopMasterPage'));

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/kiosk/live" element={
              <Suspense fallback={<div>Loading...</div>}>
                <KioskLivePage />
              </Suspense>
            } />
            {/* Instance Admin route - resolves kiosk type by join code */}
            <Route path="/kiosk/admin/:instanceId" element={<InstanceAdminPage />} />
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/approve" element={<ApproveOrderPage />} />
            <Route path="/mbti-playground" element={<MBTIPlaygroundPage />} />
            

            {/* Admin-only shop list */}
            <Route path="/shop-admin" element={<RequireRole roles={["ADMIN"]}><ShopAdminPage /></RequireRole>} />

            {/* Shop-scoped routes: owners or admins */}
            <Route path="/shops/:shopId" element={<RequireShopOwner><ShopDashboardPage /></RequireShopOwner>} />
            <Route path="/shops/:shopId/master" element={<RequireShopOwner>
              <React.Suspense fallback={<div>Loading...</div>}>
                <ShopMasterPage />
              </React.Suspense>
            </RequireShopOwner>} />
            <Route path="/shop/:shopId/photowall" element={<RequireShopOwner><PhotowallPage /></RequireShopOwner>} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
